// SEQ-240: switches the "How is this worked out" triggers off for a subtree.
//
// Used by the P&L widget editor's live preview: the preview sits inside a
// drawer that is a modal dialog with its own focus trap and a z-index far
// above the page, so a pop-up opened from it would render behind the drawer.
// The preview is a draft the user is still building, not a figure on the
// page, so it shows no triggers rather than half-working ones.
import { createContext } from "react";

export const HowWorkedOutVisibility = createContext(true);
